// Devuelve la URL de una imagen externa pasada por el proxy de la API
// (/api/image-proxy), para evitar que el navegador la bloquee (hotlinking,
// Cross-Origin-Resource-Policy same-site, falta de CORS, etc.).
const getProxiedImageUrl = (url) => {
    if (!url || typeof url !== 'string') return url
    if (!/^https?:\/\//i.test(url)) return url

    const apiBase = process.env.REACT_APP_DB_ADDRESS || ''
    if (!apiBase) return url

    return `${apiBase}/api/image-proxy?url=${encodeURIComponent(url)}`
}

export default getProxiedImageUrl